<template>
  <div id="app" class="pusen-website">
    <!-- 响应式导航栏 -->
    <!-- 替换原有 Header 部分 -->
    <el-header class="header-container" style="height:80px;">
      <div class="header-content">
        <div class="logo">
          <img src="@/assets/fslLogo.jpg" alt="普柏圣logo" class="logo-image">
          <div class="logo-text">
            <h1>普柏聖實業有限公司</h1>
            <p class="logo-subtitle">Focusolco</p>
          </div>
        </div>

        <!-- 桌面导航 -->
        <el-menu
            v-if="!isMobile"
            :default-active="activeIndex"
            class="desktop-nav"
            mode="horizontal"
            @select="handleSelect"
            background-color="transparent"
            text-color="#fff"
            active-text-color="#ffd04b">
          <el-menu-item index="1">首頁</el-menu-item>
          <el-menu-item index="2">關於我們</el-menu-item>
          <el-menu-item index="3">產品中心</el-menu-item>
          <el-menu-item index="4">服務支持</el-menu-item>
          <el-menu-item index="5">聯系我們</el-menu-item>
        </el-menu>

        <!-- 移动端汉堡按钮 -->
        <div v-if="isMobile" class="mobile-menu-btn" @click="drawer = true">
          <i class="el-icon-menu"></i>
        </div>
      </div>
    </el-header>

    <!-- 手机端侧边栏 -->
    <el-drawer
        title="菜单"
        :visible.sync="drawer"
        direction="rtl"
        size="70%"
        :with-header="false"
        custom-class="mobile-drawer">
      <el-menu
          :default-active="activeIndex"
          @select="handleSelect"
          background-color="#1a1a1a"
          text-color="#fff"
          active-text-color="#ffd04b">
        <el-menu-item index="1">首頁</el-menu-item>
        <el-menu-item index="2">關於我們</el-menu-item>
        <el-menu-item index="3">產品中心</el-menu-item>
        <el-menu-item index="4">服務支持</el-menu-item>
        <el-menu-item index="5">聯系我們</el-menu-item>
      </el-menu>
    </el-drawer>

    <!-- 主要内容 -->
    <el-main>
      <!-- 轮播图 -->
      <el-carousel :height="carouselHeight" class="main-carousel" indicator-position="outside">
        <el-carousel-item v-for="item in carouselItems" :key="item.id">
          <div class="carousel-content">
            <img :src="require(`@/assets/${item.imagePath}`)" alt="轮播图" class="carousel-image">
            <div class="carousel-caption">
              <h2>{{ item.title }}</h2>
              <p>{{ item.description }}</p>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>

      <!-- 公司简介 -->
      <section class="about-section">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="12">
            <div class="about-content">
              <h2 class="section-title">關於普柏聖</h2>
              <p class="intro-text">
                普柏聖實業有限公司是一家專註於高端汽車零配件領域的專業貿易商，致力於為客戶提供品質可靠、適配精準的歐系車輛零部件解決方案。我們長期深耕德國進口車型售後市場，主要服務於兼容<b>雙B豪華汽車品牌</b>所需的維修與更換零部件。
              </p>
              <p class="intro-text">
                公司秉持「專業、高效、誠信」的經營理念，整合多家優質供應商資源，提供涵蓋底盤、引擎、電氣系統、車身附件等多類型號的產品，適配市場主流德系車型平臺，滿足終端維修廠、配件商及電商平臺對高品質產品的多樣化需求。
              </p>
              <p class="intro-text">
                我們所銷售的零配件均來自具有穩定供貨能力的正規渠道，部分產品為OEM製造商所生產，品質與原廠標準相符，且嚴格遵守行業法規，未標註任何車輛品牌名稱與商標，確保客戶使用過程中的合規與安全。
              </p>
              <el-button type="primary" class="more-btn">了解更多</el-button>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12">
            <div class="about-image-container">
              <img src="@/assets/fslLogo.jpg" alt="公司形象" class="about-image">
            </div>
          </el-col>
        </el-row>
      </section>

      <!-- 产品展示 -->
      <section class="product-section">
        <h2 class="section-title">產品中心</h2>
        <p class="section-subtitle">為奔馳寶馬提供優質零部件解決方案</p>

        <el-row :gutter="20" class="product-list">
          <el-col :xs="24" :sm="12" :md="8" v-for="product in products" :key="product.id">
            <el-card class="product-card" shadow="hover">
              <div class="product-image-container">
                <img :src="require(`@/assets/${product.imagePath}`)" class="product-image">
              </div>
              <div class="product-info">
                <h3>{{ product.name }}</h3>
                <p class="product-desc">{{ product.description }}</p>
                <el-button type="text" class="detail-btn">查看详情</el-button>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </section>

      <!-- 优势展示 -->
      <section class="advantage-section">
        <h2 class="section-title">我們的優勢</h2>
        <el-row :gutter="30" class="advantage-list">
          <el-col :xs="24" :sm="12" :md="6" v-for="advantage in advantages" :key="advantage.id">
            <div class="advantage-item">
              <i :class="advantage.icon" class="advantage-icon"></i>
              <h3>{{ advantage.title }}</h3>
              <p>{{ advantage.description }}</p>
            </div>
          </el-col>
        </el-row>
      </section>
    </el-main>

    <!-- 页脚 -->
    <el-footer class="footer" :style="{ height: !isMobile ? '360px' : '600px' }">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="24" :md="8">
          <div class="footer-section">
            <h3>關於普柏聖</h3>
            <p>普柏聖實業有限公司致力於為雙B豪華汽車品牌</p>
            <p>提供優質的原廠配套零部件及售後服務解決方案。</p>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8">
          <div class="footer-section">
            <h3>联系我们</h3>
            <p><i class="el-icon-location"></i> 新北市中和區華新街143巷69弄18號</p>
            <p><i class="el-icon-phone"></i> 02-2948-5951 </p>
            <p><i class="el-icon-message"></i> info@pusen.com</p>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8">
          <div class="footer-section">
            <h3>快速鏈接</h3>
            <el-link type="info">首頁</el-link><br>
            <el-link type="info">產品中心</el-link><br>
            <el-link type="info">服務支持</el-link><br>
            <el-link type="info">聯系我們</el-link>
          </div>
        </el-col>
      </el-row>
      <div class="copyright">
        <p>© 2025 普柏聖實業有限公司 版權所有</p>
      </div>
    </el-footer>
  </div>
</template>

<script>

export default {
  name: 'homeFirst',
  data() {
    return {
      activeIndex: '1',
      drawer: false,
      isMobile: false,
      carouselHeight: '500px',
      carouselItems: [
        {
          id: 1,
          title: '專營雙B車系零配件',
          imagePath: 'car.png',
          description: '專注德系車輛零件供應，品質穩定、適配精準'
        },
        {
          id: 2,
          title: '原廠品質',
          imagePath: 'cover.png',
          description: '嚴選優質供應商，確保每件零件品質如一'
        },
        {
          id: 3,
          title: '售後無憂',
          imagePath: 'propshaft.jpg',
          description: '專業團隊支援，協助快速安裝與售後服務'
        }
      ],
      products: [
        {
          id: 1,
          imagePath: 'propshaft.jpg',
          name: '雙B汽車動力傳動軸',
          description: '高強度材質打造，穩定傳輸動力，適用多款德系豪華車型，提升行車平順性與耐用性。'
        },
        {
          id: 2,
          imagePath: 'cover.png',
          name: '雙B氣門室蓋',
          description: '精密製造工藝，良好密封效能，有效防止機油滲漏，確保引擎長效運轉。'
        },
        {
          id: 3,
          imagePath: 'fslLogo.jpg',
          name: '其他零件',
          description: '提供多樣化德系車用零配件，涵蓋底盤、引擎、電控等系統，滿足各類維修與升級需求'
        }
      ],
      advantages: [
        {
          id: 1,
          icon: 'el-icon-medal',
          title: '原廠品質',
          description: '嚴格遵循原廠標準，品質有保障'
        },
        {
          id: 2,
          icon: 'el-icon-price-tag',
          title: '價格優勢',
          description: '廠家直供，價格更具競爭力'
        },
        {
          id: 3,
          icon: 'el-icon-truck',
          title: '快速交付',
          description: '充足庫存，快速響應客戶需求'
        },
        {
          id: 4,
          icon: 'el-icon-headset',
          title: '專業服務',
          description: '專業技術團隊，提供完善售後服務'
        }
      ]
    }
  },
  created() {
    this.isMobile = this.isMobileShow();
  },
  methods: {
    handleSelect(key) {
      this.activeIndex = key;
      if (this.isMobile) {
        this.drawer = false;
      }
      // 这里可以添加导航跳转逻辑
    },
    checkIsMobile() {
      this.isMobile = window.innerWidth < 768;
      this.carouselHeight = this.isMobile ? '300px' : '500px';
    },
    isMobileShow() {
      return window.innerWidth < 768;
    },
    handleResize() {
      this.checkIsMobile();
    }
  },
  mounted() {
    this.checkIsMobile();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }
}
</script>

<style scoped>
.pusen-website {
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', Arial, sans-serif;
  color: #333;
  min-width: 320px;
}

/* 头部样式 */
/* Header 优化样式 */
.header-container {
  background-color: #1a1a1a;
  color: white;
  height: 80px;
  padding: 0;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  display: flex;
  align-items: center;
}

.logo-image {
  height: 40px;
  margin-right: 10px;
}

.logo-text h1 {
  margin: 0;
  font-size: 18px;
  font-weight: bold;
  line-height: 1.2;
}

.logo-subtitle {
  margin: 0;
  font-size: 12px;
  color: #ccc;
  display: none;
}

.desktop-nav {
  border-bottom: none;
}

.desktop-nav >>> .el-menu-item {
  height: 60px;
  line-height: 60px;
  padding: 0 15px;
}

.mobile-menu-btn {
  font-size: 24px;
  color: white;
  cursor: pointer;
}


/* 主要内容区域 - 添加顶部内边距避免被固定头部遮挡 */
.el-main {
  padding: 0;
  margin-top: 60px;
}

/* 轮播图样式 */
.main-carousel {
  margin-bottom: 30px;
}

.carousel-content {
  position: relative;
  width: 100%;
  height: 100%;
}

.carousel-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-color: #f5f7fa;
}

.carousel-caption {
  position: absolute;
  bottom: 20%;
  left: 10%;
  right: 10%;
  text-align: center;
  color: #1a1a1a;
  background-color: rgba(255, 255, 255, 0.8);
  padding: 20px;
  border-radius: 4px;
}

.carousel-caption h2 {
  font-size: 1.5rem;
  margin-bottom: 10px;
}

.carousel-caption p {
  font-size: 1rem;
  margin: 0;
}

/* 内容区域样式 */
.section-title {
  text-align: center;
  font-size: 1.75rem;
  margin-bottom: 1rem;
  color: #1a1a1a;
  font-weight: bold;
}

.section-subtitle {
  text-align: center;
  color: #666;
  margin-bottom: 2rem;
  font-size: 1rem;
}

/* 关于我们区域 */
.about-section {
  padding: 3rem 1rem;
  background-color: #f9f9f9;
}

.about-content {
  padding: 1rem;
}

.intro-text {
  line-height: 1.6;
  margin-bottom: 1rem;
  color: #555;
  font-size: 0.9rem;
}

.more-btn {
  margin-top: 1rem;
  width: 100%;
}

.about-image-container {
  padding: 1rem;
  text-align: center;
}

.about-image {
  max-width: 100%;
  height: auto;
  max-height: 300px;
  object-fit: contain;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  background-color: #f5f7fa;
  padding: 1rem;
}

/* 产品区域 */
.product-section {
  padding: 3rem 1rem;
  background-color: white;
}

.product-list {
  margin-top: 1.5rem;
}

.product-card {
  margin-bottom: 1rem;
  transition: all 0.3s;
  height: 100%;
}

.product-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.1);
}

.product-image-container {
  height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f7fa;
  padding: 1rem;
}

.product-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.product-info {
  padding: 1rem;
}

.product-desc {
  color: #666;
  margin: 0.5rem 0;
  font-size: 0.8rem;
  height: 3.6rem;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.detail-btn {
  color: #409EFF;
  padding: 0;
  font-size: 0.8rem;
}

/* 优势区域 */
.advantage-section {
  padding: 3rem 1rem;
  background-color: #f5f7fa;
}

.advantage-list {
  margin-top: 2rem;
}

.advantage-item {
  text-align: center;
  padding: 1.5rem 1rem;
  background: white;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 1rem;
  height: calc(100% - 1rem);
}

.advantage-icon {
  font-size: 2.5rem;
  color: #409EFF;
  margin-bottom: 1rem;
}

.advantage-item h3 {
  margin: 0.5rem 0;
  font-size: 1.1rem;
}

.advantage-item p {
  font-size: 0.8rem;
  color: #666;
  margin: 0;
}

/* 页脚样式 */
.footer {
  background-color: #1a1a1a;
  color: #aaa;
  padding: 2rem 1rem 1rem;
}

.footer-section {
  margin-bottom: 1.5rem;
  padding: 0 0.5rem;
}

.footer-section h3 {
  color: white;
  margin-bottom: 1rem;
  font-size: 1.1rem;
}

.footer-section p {
  line-height: 1.6;
  margin: 0.5rem 0;
  font-size: 0.8rem;
}

.footer-section i {
  margin-right: 0.5rem;
}

.el-link {
  margin: 0.3rem 0;
  font-size: 0.8rem;
}

.copyright {
  text-align: center;
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid #333;
  color: #666;
  font-size: 0.7rem;
}
/* 移动端菜单全黑背景 */
>>> .mobile-drawer {
  background-color: #000 !important;
}
>>> .mobile-drawer .el-drawer__body {
  padding: 0;
}
>>> .mobile-drawer .el-menu {
  border-right: none;
}
/* 响应式设计 - 平板及以上 */
@media (min-width: 768px) {
  .header {
    padding: 0 2rem;
    height: 80px;
    line-height: 80px;
  }

  .logo-image {
    height: 50px;
  }

  .logo-text h1 {
    font-size: 1.5rem;
  }

  .logo-subtitle {
    display: block;
  }

  .el-main {
    margin-top: 80px;
  }

  .carousel-caption {
    bottom: 30%;
    left: 15%;
    right: 15%;
    padding: 2rem;
  }

  .carousel-caption h2 {
    font-size: 2rem;
  }

  .carousel-caption p {
    font-size: 1.2rem;
  }

  .section-title {
    font-size: 2rem;
  }

  .section-subtitle {
    font-size: 1.1rem;
  }

  .about-section, .product-section, .advantage-section {
    padding: 4rem 2rem;
  }

  .intro-text {
    font-size: 1rem;
  }

  .more-btn {
    width: auto;
  }

  .footer {
    padding: 3rem 2rem 1.5rem;
  }

  .footer-section h3 {
    font-size: 1.2rem;
  }

  .footer-section p, .el-link {
    font-size: 0.9rem;
  }
}

/* 响应式设计 - 桌面 */
@media (min-width: 768px) {
  .header-content {
    height: 80px;
    padding: 0 30px;
  }

  .logo-image {
    height: 50px;
  }

  .logo-text h1 {
    font-size: 22px;
  }

  .logo-subtitle {
    display: block;
  }

  .desktop-nav >>> .el-menu-item {
    height: 80px;
    line-height: 80px;
    padding: 0 20px;
    font-size: 16px;
  }
}


</style>